import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { DATE_FIELD_START } from "../../constants/dateFields";
import dateFunctions, { isDateValid } from "../../modules/definition/calendar/dateFunctions";
import { Precision, PropTypeShapes } from "../../types";
import { DateRecord } from "../../types/immutableRecords/model/data/DateRecord";
import CalendarPicker from "../calendarPicker";
import MenuPopover from "./MenuPopover";

export default class DateMenuPopover extends PureComponent {
  constructor(props) {
    super(props);

    this._dateNow = dateFunctions.dateForNow(this.props.calendar);

    this.state = {
      date: props.defaultDate || DateRecord({ precision: Precision.Second })
    };
    this._date = this.state.date;
    this.setDate = this.setDate.bind(this);
    this.onOk = this.onOk.bind(this);
    this.setDatePrecision = this.setDatePrecision.bind(this);
  }

  setDate(date) {
    let newDate = date;
    // Keep date within timeline range
    if (isDateValid(this.props.dateRangeFrom) && newDate.timestamp < this.props.dateRangeFrom.timestamp) {
      newDate = this.props.dateRangeFrom;
    } else if (isDateValid(this.props.dateRangeTo) && newDate.timestamp > this.props.dateRangeTo.timestamp) {
      newDate = this.props.dateRangeTo;
    }

    this.setState({ date: newDate });
    this._date = newDate;
  }

  setDatePrecision(newPrecision) {
    const newDate = this.state.date.set("precision", newPrecision);
    this._date = newDate;
    this.setDate(newDate);
  }

  getIsDateValid() {
    const { isValidDate } = this.props;
    return isDateValid(this._date) && (!isValidDate || isValidDate(this._date));
  }

  onOk() {
    if (this.getIsDateValid()) {
      this.props.onOk(this._date);
    }
  }

  render() {
    const {
      target,
      isOpen,
      title,
      topDescription,
      bottomDescription,
      buttonLabel,
      showCancel,
      extraInlineComps
    } = this.props;

    return (
      <MenuPopover
        target={target}
        isOpen={isOpen}
        title={title}
        onOk={this.getIsDateValid() ? this.onOk : null}
        onCancel={this.props.onCancel}
        onEnter={this.onOk}
        buttonLabel={buttonLabel}
        topDescription={topDescription}
        bottomDescription={bottomDescription}
        showCancel={showCancel}
        isVerticalLayout={true}
      >
        <div className="calendarPickerChildren">
          <CalendarPicker
            calendar={this.props.calendar}
            startDate={this.state.date}
            allowUncertainDates={false}
            isDual={false}
            onStartDateChange={this.setDate}
            dateForNow={this._dateNow}
            selectedDateField={DATE_FIELD_START}
            onPrecisionChange={this.setDatePrecision}
            isFixedPrecision={true}
          />
        </div>
        {extraInlineComps}
      </MenuPopover>
    );
  }
}

DateMenuPopover.propTypes = {
  target: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  calendar: PropTypeShapes.calendar.isRequired,
  topDescription: PropTypes.string,
  bottomDescription: PropTypes.string,
  buttonLabel: PropTypes.string,
  defaultDate: PropTypeShapes.dateRecord,
  showCancel: PropTypes.bool,
  isValidDate: PropTypes.func,
  extraInlineComps: PropTypeShapes.elementOrArray,
  dateRangeFrom: PropTypeShapes.date,
  dateRangeTo: PropTypeShapes.date
};
